module.exports = __webpack_public_path__ + "static/media/isner_ballboy.fbd1c4e5.jpg";